<template>
  <summary-section heading="Bio">
    <template v-if="userIsOnTheirOwnProfile" v-slot:actions>
      <router-link
        to="/profile/questions/bio"
        class="summary-section__action-link"
      >
        Edit
      </router-link>
    </template>
    <template class="user-bio-summary">
      <p v-if="user.bio" class="user-bio-summary__bio">
        {{ showFullBio ? user.bio : truncateBio(user.bio) }}
        <button v-if="bioIsTruncated" class="user-bio-summary__button text-button" @click="toggleBioVisibility">
          <span class="user-bio-summary__button-text">{{ showFullBio ? 'View less' : 'View more' }}</span>
          <icon-component
            name="caret"
            title="Expand bio"
            :class="['user-bio-summary__button-icon', { 'user-bio-summary__button-icon--expanded': showFullBio }]"
          />
        </button>
      </p>
      <p v-else class="user-bio-summary__placeholder">
        What's your story?
      </p>
    </template>
  </summary-section>
</template>

<script>
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'UserBioSummary',
  components: {
    SummarySection,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showFullBio: false,
      bioIsTruncated: false,
    };
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    userIsOnTheirOwnProfile() {
      return this.user.id === this.currentUser.id;
    },
  },
  methods: {
    truncateBio(bio) {
      const truncationLimit = 200;
      if (bio.length <= truncationLimit) {
        this.bioIsTruncated = false;
        return bio;
      }
      this.bioIsTruncated = true;
      return `${bio.substring(0, truncationLimit)}...`;
    },
    toggleBioVisibility() {
      this.showFullBio = !this.showFullBio;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_user-bio-summary';
</style>
